/**
 * Utilitários para formatação e exibição de entidades do sistema
 */

/**
 * Obtém o nome formatado do profissional a partir do objeto ou ID
 * 
 * @param {Object|string} profissional - Objeto do profissional ou ID
 * @param {Array} professionalsList - Lista de profissionais para busca por ID (opcional)
 * @returns {string} - Nome do profissional formatado
 */
export const getProfessionalName = (profissional, professionalsList = []) => {
  if (!profissional) return 'Não especificado';
  
  // Se o profissional já for um objeto com nome, usar diretamente
  if (typeof profissional === 'object' && profissional.nome) {
    return profissional.nome;
  }
  
  // Se for apenas o ID, buscar na lista de profissionais
  const profissionalId = profissional;
  
  // Buscar o profissional pelo ID na lista de profissionais
  if (Array.isArray(professionalsList) && professionalsList.length > 0) {
    const foundProfessional = professionalsList.find(p => p.id === profissionalId);
    if (foundProfessional && foundProfessional.nome) {
      return foundProfessional.nome;
    }
  }
  
  // Fallback para casos onde não foi possível encontrar o nome
  return profissionalId || 'Não especificado';
};

/**
 * Formata o número de telefone para visualização
 * 
 * @param {string} number - Número de telefone a ser formatado
 * @returns {string} - Número formatado
 */
export const formatPhoneNumber = (number) => {
  if (!number) return 'Não informado';
  
  // Remover caracteres não numéricos
  const numericOnly = number.replace(/\D/g, '');
  
  // Se o número não tiver 10 ou 11 dígitos, retornar como está
  if (numericOnly.length < 10 || numericOnly.length > 11) {
    return number;
  }
  
  // Separar os componentes do número
  const ddd = numericOnly.substring(0, 2);
  const part1 = numericOnly.substring(2, 7);
  const part2 = numericOnly.substring(7);
  
  // Montar o número formatado
  return `(${ddd}) ${part1}-${part2}`;
};

/**
 * Obtém a lista de serviços formatada como texto
 * 
 * @param {Array} servicos - Lista de serviços
 * @returns {string} - Serviços formatados como texto
 */
export const getFormattedServicesList = (servicos) => {
  if (!servicos) {
    return 'Serviço não especificado';
  }
  
  return Array.isArray(servicos)
    ? servicos
        .map(s => typeof s === 'object' && s.nome ? s.nome : 'Serviço')
        .join(', ')
    : 'Serviço não especificado';
}; 